import { useEffect, useCallback } from 'react';
import Icon from '@components/icons/Icon';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/Aside/Aside.styles';
import Button from '@components/Button/Button';
import { TButtonVariantColor, TButtonVariantBackgroundColor } from '@components/Button/typescript';
import useBodyOverflow from '@hooks/useBodyOverflow';
export type AsidePropsType = {
  children: React.ReactNode;
  active: boolean;
  buttonCloseVariantColor?: TButtonVariantColor;
  buttonCloseVariantBackgroundColor?: TButtonVariantBackgroundColor;
  useCurtain?: boolean;
  size?: 'default' | 'large';
  overflowY?: string;
  overflowX?: string;
  onCloseAside: (...args: unknown[]) => void;
};
const Aside = ({
  children,
  active,
  buttonCloseVariantColor = undefined,
  buttonCloseVariantBackgroundColor = undefined,
  useCurtain = true,
  size = 'default',
  overflowY = 'auto',
  overflowX = 'hidden',
  onCloseAside
}: AsidePropsType): JSX.Element => {
  const handleKeyUp = useCallback((event: KeyboardEvent) => {
    const {
      key
    } = event;
    if (key === 'Escape') onCloseAside(event);
  }, [onCloseAside]);
  const onOverlayClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event.target === event.currentTarget && event.button === 0) onCloseAside(event);
  };
  useBodyOverflow(active, 'asideCMS', true);
  useEffect(() => {
    if (active) {
      window.addEventListener('keyup', handleKeyUp);
    } else {
      window.removeEventListener('keyup', handleKeyUp);
    }
    return () => window.removeEventListener('keyup', handleKeyUp);
  }, [active, handleKeyUp]);
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: overlay click handler
    // biome-ignore lint/a11y/noNoninteractiveElementInteractions: overlay click handler
    <div sx={styles.overlay(active, useCurtain)} onMouseDown={onOverlayClick}>
      <aside sx={styles.aside(active, size || 'default', overflowY, overflowX)}>
        <div sx={styles.asideContent}>
          <div sx={styles.closeContainer}>
            <Button variant="iconOnly" type="button" onClick={onCloseAside} variantColor={buttonCloseVariantColor} variantBackgroundColor={buttonCloseVariantBackgroundColor}>
              <Icon size="24px" icon="Close3" />
            </Button>
          </div>
          {children}
        </div>
      </aside>
    </div>
  );
};
export default Aside;